import { PluginKey } from '@atlaskit/editor-prosemirror/state';
export var gapCursorPluginKey = new PluginKey('gapCursorPlugin');